import React from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';

import { Form } from 'common/components';
import Validated from 'components/util/Validated';
import * as FormSections from 'notifications_config/components/form/sections';

import { createRoute } from 'lib/util';

const NotificationsConfigForm = ({
  notification_config,
  company,
  depreciations,
  errors,
  notifications_elementsBySections,
  allSections,
  handleAddCustomField,
  handleRemoveCustomField,
  handleSubmit,
  handleValueChange,
  handleGroupChange, //Groups
  handleCustomFieldChange, //Groups
  groups, //Groups
  isSaving,
  isSubmitted,
  subcompany,
  t,
  values,

  handleAddToNotify,
  handleRemoveToNotify,

  handleCheckSection,
  handleCheckPermission,
  handleClickPermissionRow,
}) => {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}
    >
      <FormSections.General
        notification_config={notification_config}
        errors={errors}
        values={values}
        handleValueChange={handleValueChange}
        isSubmitted={isSubmitted}
      />

      <FormSections.Users
        notification_config={notification_config}
        handleAddToNotify={handleAddToNotify}
        handleRemoveToNotify={handleRemoveToNotify}
        errors={errors}
        values={values}
        handleValueChange={handleValueChange}
        isSubmitted={isSubmitted}
      />

      {/* <FormSections.Depreciations
        depreciations={depreciations}
        errors={errors}
        values={values}
        handleValueChange={handleValueChange}
        isSubmitted={isSubmitted}
      />

      <FormSections.CustomFields
        depreciations={depreciations}
        errors={errors}
        values={values}
        handleAddCustomField={handleAddCustomField}
        handleRemoveCustomField={handleRemoveCustomField}
        handleValueChange={handleValueChange}
        isSubmitted={isSubmitted}
      /> */}

      <FormSections.Elements
        errors={errors}
        handleCustomFieldChange={handleCustomFieldChange}
        handleGroupChange={handleGroupChange}
        handleCheckSection={handleCheckSection}
        handleCheckPermission={handleCheckPermission}
        handleClickPermissionRow={handleClickPermissionRow}
        isSubmitted={isSubmitted}
        t={t}
        values={values}
        notifications_elementsBySections={notifications_elementsBySections}
        allSections={allSections}
      ></FormSections.Elements>

      <div className="col-md-12 mt-3">
        <Form.Button
          type={'submit'}
          text={t('actions.save')}
          isLoading={isSaving}
          disabled={isSaving}
          extraClassName={'pull-right btn-xs-block'}
        />

        <Form.Link
          to={createRoute(company.id, subcompany.id, `notifications_config`)}
          className={classnames('btn btn-secondary pull-right mr-3', {
            disabled: isSaving,
          })}
        >
          {t('actions.cancel')}
        </Form.Link>
        <div className="clearfix" />
      </div>
    </form>
  );
};

export default Validated({
  type: 'object',
  properties: {
    key: {
      type: 'string',
      minLength: 1,
    },
    name: {
      type: 'string',
      minLength: 1,
    },
    send_mail: {
      type: 'boolean',
      minLength: 1,
    },
  },
  required: ['name'],
})(translate()(NotificationsConfigForm));



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_config/components/form/NotificationConfigForm.js